export const GRAY_600 = '#72727c';
export const PURPLE = '#7859ab';
export const WARNING = '#e56901';
export const GRAY = '#333333';
export const WHITE = '#ffffff';